import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
        .filter(Boolean)
        .join(" ") || "Validation error."
    );
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function buildWsUrl(path) {
  // BACKEND is https://...preview.emergentagent.com — turn to wss://
  const base = BACKEND.replace(/^http/, "ws");
  return `${base}${path}`;
}
